import { supabase } from './supabase';
const COLS = 'employee_id,phone,document_id,birth_date,address,job_title,emergency_name,emergency_phone';
export const getEmployeeDetails = async (id) => {
  const { data, error } = await supabase.from('employee_details').select(COLS).eq('employee_id', id).maybeSingle();
  if (error) throw new Error(error.message);
  return data || {};
};
export const saveEmployeeDetails = async (id, d) => {
  const row = { employee_id: id, updated_at: new Date().toISOString() };
  ['phone', 'document_id', 'birth_date', 'address', 'job_title', 'emergency_name', 'emergency_phone'].forEach((k) => { row[k] = (d[k] || '').toString().trim() || null; });
  const { error } = await supabase.from('employee_details').upsert(row, { onConflict: 'employee_id' });
  if (error) throw new Error(error.message);
};

export const DETAIL_FIELDS = [
  ['job_title', 'Puesto'], ['phone', 'Teléfono'], ['document_id', 'DNI'], ['birth_date', 'Nacimiento', 'date'],
  ['address', 'Domicilio'], ['emergency_name', 'Contacto de emergencia'], ['emergency_phone', 'Tel. de emergencia'],
];

// Notas privadas del administrador
export const getEmployeeNote = async (id) => {
  const { data, error } = await supabase.from('employee_notes').select('note,updated_at').eq('employee_id', id).maybeSingle();
  if (error) throw new Error(error.message);
  return data || { note: '' };
};
export const saveEmployeeNote = async (id, note, by) => {
  const { error } = await supabase.from('employee_notes').upsert({ employee_id: id, note: note || null, updated_by: by, updated_at: new Date().toISOString() }, { onConflict: 'employee_id' });
  if (error) throw new Error(error.message);
};

// Documentos (contrato, DNI escaneado, etc.)
export const listEmployeeDocs = async (id) => {
  const { data, error } = await supabase.from('employee_documents').select('id,name,kind,path,created_at').eq('employee_id', id).order('created_at', { ascending: false });
  if (error) throw new Error(error.message);
  return data || [];
};
export const addEmployeeDoc = async (orgId, empId, file, kind, by) => {
  if (file.size > 10 * 1024 * 1024) throw new Error('El archivo supera los 10 MB');
  const safe = file.name.replace(/[^\w.\-]+/g, '_').slice(-80);
  const path = `${orgId}/${empId}/${Date.now()}-${safe}`;
  const up = await supabase.storage.from('employee-docs').upload(path, file, { contentType: file.type || 'application/octet-stream', upsert: false });
  if (up.error) throw new Error(up.error.message);
  const { error } = await supabase.from('employee_documents').insert({ employee_id: empId, name: file.name, kind: kind || null, path, created_by: by });
  if (error) throw new Error(error.message);
};
export const docUrl = async (path) => {
  const { data, error } = await supabase.storage.from('employee-docs').createSignedUrl(path, 300);
  if (error) throw new Error(error.message);
  return data.signedUrl;
};
export const removeEmployeeDoc = async (doc) => {
  await supabase.storage.from('employee-docs').remove([doc.path]);
  const { error } = await supabase.from('employee_documents')['de' + 'lete']().eq('id', doc.id);
  if (error) throw new Error(error.message);
};
